import React, { useContext } from "react";
import { Checkbox, Slider, InputNumber, Row, Col, Space, Typography } from "antd";
import MaterialInspectorContext from "../contextFiles/MaterialInspectorContext";

const { Text } = Typography;

const MaterialDebugPanel = (props) => {
    const { horizontalRepeat, verticalRepeat, setHorizontalRepeat, setVerticalRepeat, repeatLock, setRepeatLock } = useContext(MaterialInspectorContext);

    const handleHorizontalRepeat = (value) => {
        setHorizontalRepeat(value);
        if (repeatLock) {
            setVerticalRepeat(value);
        }
    }

    const handleRepeatLock = (e) => {
        setRepeatLock(!repeatLock);
        if (repeatLock) {
            setVerticalRepeat(horizontalRepeat);
        }
    }

    const responsiveStyles = {
        container: {
            padding: '4px',
            width: '100%',
            maxWidth: '100%',
        },
        label: {
            fontSize: '12px',
            fontWeight: '500',
            color: '#262626',
            marginBottom: '4px',
            display: 'block',
        },
        sliderContainer: {
            marginBottom: '4px',
            padding: '4px',
            backgroundColor: '#ffffff',
            borderRadius: '6px',
        },
        inputNumber: {
            width: '100%',
            minWidth: '70px',
            borderRadius: '4px',
        },
        checkbox: {
            fontSize: '12px',
            marginBottom: '4px',
            padding: '4px 4px',
            backgroundColor: '#ffffff',
            borderRadius: '6px',
        },
        slider: {
            marginTop: '2px',
        },
        // Mobile styles
        mobile: {
            container: {
                padding: '6px',
            },
            label: {
                fontSize: '11px',
                marginBottom: '3px',
            },
            sliderContainer: {
                marginBottom: '4px',
                padding: '4px',
            },
            checkbox: {
                fontSize: '11px',
                marginBottom: '4px',
                padding: '3px 4px',
            },
        },
        // Tablet styles
        tablet: {
            container: {
                padding: '7px',
            },
        },
    };

    return (
        <div style={responsiveStyles.container}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <div style={responsiveStyles.checkbox}>
                    <Checkbox 
                        onChange={handleRepeatLock} 
                        checked={repeatLock}
                        style={{ fontSize: '12px', fontWeight: '500' }}
                    >
                        Lock Axis
                    </Checkbox>
                </div>

                <div style={responsiveStyles.sliderContainer}>
                    <Text style={responsiveStyles.label}>Horizontal Repeat</Text>
                    <Row gutter={[8, 4]} align="middle">
                        <Col xs={24} sm={16} md={14} lg={12} xl={10}>
                            <Slider
                                min={0.001}
                                max={2}
                                onChange={handleHorizontalRepeat}
                                value={horizontalRepeat}
                                step={0.01}
                                style={responsiveStyles.slider}
                            />
                        </Col>
                        <Col xs={24} sm={8} md={10} lg={12} xl={14}>
                            <InputNumber
                                min={0.001}
                                max={2}
                                style={responsiveStyles.inputNumber}
                                step={0.01}
                                value={horizontalRepeat}
                                onChange={handleHorizontalRepeat}
                                bordered={true}
                                size="small"
                            />
                        </Col>
                    </Row>
                </div>

                <div style={responsiveStyles.sliderContainer}>
                    <Text style={responsiveStyles.label}>Vertical Repeat</Text>
                    <Row gutter={[8, 4]} align="middle">
                        <Col xs={24} sm={16} md={14} lg={12} xl={10}>
                            <Slider
                                min={0.001}
                                max={2}
                                onChange={setVerticalRepeat}
                                value={verticalRepeat}
                                step={0.01}
                                disabled={repeatLock}
                                style={responsiveStyles.slider}
                            />
                        </Col>
                        <Col xs={24} sm={8} md={10} lg={12} xl={14}>
                            <InputNumber
                                min={0.001}
                                max={10.0}
                                disabled={repeatLock}
                                style={responsiveStyles.inputNumber}
                                step={0.01}
                                value={verticalRepeat}
                                onChange={setVerticalRepeat}
                                bordered={true}
                                size="small"
                            />
                        </Col>
                    </Row>
                </div>
            </Space>
        </div>
    );
};

export default MaterialDebugPanel;